window.addEventListener('load', (event) =>  {
    let tab = document.getElementById('section-tabs');
    let tabPosition = tab.getBoundingClientRect().top + window.scrollY;
    let sections = document.querySelectorAll(".cls-stn-tabs");
    let tabLink = document.querySelectorAll(".tab-link");
    let documentHeight = document.documentElement.scrollHeight;
    let annoucenBar = document.getElementById('qab_container');
    let Header = document.getElementById('myHeader');

    let headerHeight = Header.offsetHeight;
    let annoucenBarHeight = annoucenBar ? annoucenBar.offsetHeight : 0;
    console.log('Height using offsetHeight:', annoucenBarHeight);
    console.log("headerHeight", headerHeight);

    // Función para actualizar el top del tab
    function updateTabTop() {
        headerHeight = Header.offsetHeight;
        annoucenBarHeight = annoucenBar ? annoucenBar.offsetHeight : 0;
        if (tab.classList.contains("active")) {
            tab.style.top = `${headerHeight + annoucenBarHeight}px`;
        }
    }

    // Configurar MutationObserver para observar cambios en el annoucenBar
    if (annoucenBar) {
        const observer = new MutationObserver(updateTabTop);
        observer.observe(annoucenBar, { attributes: true, childList: true, subtree: true });
    }

    window.addEventListener("scroll", () => {
        let currentScrollY = window.scrollY;
        let windowHeight = window.innerHeight;

        if (currentScrollY > tabPosition) {
            tab.classList.add("active");
            updateTabTop();
        } else {
            tab.classList.remove("active");
            tab.style.top = ''; 
        }

        sections.forEach((section, index) => {
            let sectionTop = section.getBoundingClientRect().top + window.scrollY;

            if ((currentScrollY + windowHeight / 2 >= sectionTop) && (currentScrollY + windowHeight / 2 <= sectionTop + section.getBoundingClientRect().height)) {
                tabLink.forEach(element => {
                    element.classList.remove("active");
                });
                tabLink[index].classList.add("active");
            }
        });

        if (currentScrollY + windowHeight >= documentHeight - 600) {
            tab.classList.remove('active');
        }
    });
});